import "./YourInfiniteSelves.module.css";
import Header from "@/reusable_sections/Header";
import { CosmicBackground } from "@/components/cosmic/CosmicBackground";
import IntroHero from "./sections/IntroHero";
import HowItWorks from "./sections/HowItWorks";
import SelfStudio from "./sections/SelfStudio";
import DreamBridge from "./bridge/DreamBridge";
import IdeaAndPrivacy from "./sections/IdeaAndPrivacy";
import UniverseBridge from "./sections/UniverseBridge";
import Footer from "@/reusable_sections/Footer";
export default function YourInfiniteSelvesPage() {
  return <div className="relative min-h-screen min-h-[100svh] bg-background text-foreground flex flex-col w-full max-w-full overflow-x-hidden">
      {/* Shared fixed cosmic canvas & drifted nebula backdrop */}
      <CosmicBackground fixed accent="violet" density={1} />

      <Header />
      <main className="relative z-10 flex-1 w-full max-w-full">
        <IntroHero />
        <HowItWorks />
        <SelfStudio />
        <DreamBridge />
        <IdeaAndPrivacy />
        <UniverseBridge />
      </main>
      <Footer />
    </div>;
}